import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/rh/planning/create")({
  loader: requirePermission(PERMISSIONS.RH.FEUILLES_DE_TEMPS.CREATE),
  staticData: {
    title: "Créer un élément",
    icon: PlusCircle,
    permission: PERMISSIONS.RH.FEUILLES_DE_TEMPS.CREATE,
  },
  component: () => (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Créer un élément de planning</h1>
      <p className="text-base-content/60">Le formulaire de création sera implémenté ici.</p>
    </div>
  ),
});
